import React from "react";
import nextId from "react-id-generator";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./candidate-landing.style.scss";
import JobCard from "./JobCard/JobCard";
import CommonFooter from "../CommonFooter/CommonFooter";
import {
  getAllJobs,
  getAllTestimonials,
  getFeaturedJobs,
} from "../../../APIs/GetAPIs";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
export default function CandidateLanding({ initial }) {
  const context = React.useContext(MainContext);
  const { totalJobCount, totalInstituteCount } = context;
  const [fLoading, setFLoading] = React.useState(true);
  const [carousalList, setCarousalList] = React.useState([]);
  const [commentList, setCommentList] = React.useState({
    institute: [],
    candidate: [],
  });
  const [testimonials, setTestimonials] = React.useState("candidate");
  const [searchConfig, setSearchConfig] = React.useState({
    title: "",
    location: "",
    distance: "",
  });
  const [selectedComment, setSelectedComment] = React
    .useState
    // comments.candidate[0]
    ();
  const [selectedJob, setSelectedJob] = React.useState({
    belongsTo: 1,
    cards: [],
  });

  const returnClassName = (obj) => {
    if (obj.belongsTo < selectedJob.belongsTo) {
      return "carousal-left";
    } else if (obj.belongsTo > selectedJob.belongsTo) {
      return "carousal-right";
    } else {
      return "carousal-middle";
    }
  };

  const returnCommentClassName = (obj) => {
    if (obj.num < selectedComment.num) {
      return "comment-left";
    } else if (obj.num > selectedComment.num) {
      return "comment-right";
    } else {
      return "comment-middle";
    }
  };

  const handlePreviousButton = () => {
    if (!selectedComment.num) return;
    setSelectedComment(commentList[testimonials][selectedComment.num - 1]);
  };

  const handleNextButton = () => {
    if (selectedComment.num + 1 === commentList[testimonials].length) return;
    setSelectedComment(commentList[testimonials][selectedComment.num + 1]);
  };
  const setUpCommentList = async () => {
    let res = await getAllTestimonials();
    if (res.data.statusCode === 200) {
      let temp = { institute: [], candidate: [] };
      let numOne = 0;
      let numTwo = 0;
      res.data.data.map((obj) => {
        if (obj.testimonial_type === "institute") {
          temp = {
            ...temp,
            institute: [...temp.institute, { ...obj, num: numOne }],
          };
          numOne = numOne + 1;
        } else {
          temp = {
            ...temp,
            candidate: [...temp.candidate, { ...obj, num: numTwo }],
          };
          numTwo = numTwo + 1;
        }
      });
      if (temp.candidate.length) {
        setSelectedComment(temp.candidate[0]);
      } else {
        setSelectedComment(temp.institute[0]);
      }
      setCommentList({ ...temp });
    } else {
    }
  };
  const setUpFeatureJobs = async () => {
    setFLoading(true);
    try {
      let res = await getAllJobs({
        jobTitle: "",
        city: "",
        country: "",
        jobCategory: "",
        custField4: "",
        jobDescription: "",
        start: "1",
        numOfRecords: "12",
        websitePublish: "",
        custField1: [""],
        jobType: [""],
        minSalary: "0",
        maxSalary: "100000000",
      });
      if (res.data.data) {
        let count = 1;
        let tempArr = [];
        let tempFinalArr = [];
        let temp = res.data.data;

        temp.map((obj, num) => {
          tempArr = [...tempArr, obj];

          if (!((num + 1) % 3)) {
            tempFinalArr = [
              ...tempFinalArr,
              { belongsTo: count, cards: [...tempArr] },
            ];
            tempArr = [];
            count = count + 1;
          } else if (temp.length - 1 === num) {
            tempFinalArr = [
              ...tempFinalArr,
              { belongsTo: count, cards: [...tempArr] },
            ];
          }
        });
        setCarousalList([...tempFinalArr]);
      }
      setFLoading(false);
    } catch (error) {
      setFLoading(false);
    }
  };
  React.useEffect(() => {
    setUpFeatureJobs();
  }, []);
  React.useEffect(() => {
    setUpCommentList();
  }, []);
  React.useEffect(() => {
    initial();
  }, []);
  let mainRef = React.useRef();
  return (
    <div className="candidate-landing-main">
      <section
        style={{ backgroundImage: `url(${Images.bgImage})` }}
        className="candidate-search-and-featured"
      >
        <div className="candidate-search-wrapper">
          <div className="bottom-border" />
          <p className="above-title">It’s simple & smart</p>
          <h1>
            Find Teaching Jobs <b>Today!</b>{" "}
          </h1>
          <div className="jobs-number">
            <div>
              <h6 style={{ marginRight: 5 }}>
                <button>
                  <img src={Images.jobsLogo} />
                </button>
                {totalJobCount}
              </h6>
              <span>Jobs</span>
            </div>
            <div>
              <h6 style={{ marginRight: 5 }}>
                <button>
                  <img src={Images.instituteLogo} />
                </button>
                {totalInstituteCount || "0"}{" "}
              </h6>
              <span>Institutes</span>
            </div>
            <div>
              <h6 style={{ marginRight: 5 }}>
                <button>
                  <img src={Images.groupLogo} />
                </button>
                343635+
              </h6>
              <span>Candidate Database</span>
            </div>
          </div>
          <div className="search-section-wrapper">
            <div className="search-section">
              <div className="inside-search search-job-title">
                <img src={Images.penLogo} alt="edit" />
                <input
                  value={searchConfig.title}
                  onChange={(e) =>
                    setSearchConfig({ ...searchConfig, title: e.target.value })
                  }
                  placeholder="Job title"
                />
              </div>
              <div className="inside-search search-location">
                <span />
                <img src={Images.locationLogo} alt="edit" />
                <input
                  value={searchConfig.location}
                  onChange={(e) =>
                    setSearchConfig({
                      ...searchConfig,
                      location: e.target.value,
                    })
                  }
                  placeholder="location"
                />
                <span />
              </div>
              <div className="inside-search search-submit">
                <Link
                  onClick={(e) =>
                    !searchConfig.title && !searchConfig.location
                      ? e.preventDefault()
                      : console.log()
                  }
                  to={`/user/list/search?jobTitle=${searchConfig.title}&location=${searchConfig.location}`}
                >
                  Search
                </Link>
              </div>
            </div>
            <div className="search-trending-keywords">
              <p>
                <span>Trending Keywords:</span>Science Teacher, English Teacher
              </p>
            </div>
          </div>
        </div>
        <div className="featured-jobs-section">
          <h5 className="f-j-s-title">Featured Jobs Circulars</h5>
          <div className="featured-job-carousal">
            <div className="f-j-carousal-list">
              {fLoading
                ? [{ belongsTo: 0, cards: [1, 2, 3] }].map((x) => (
                    <div className={`carousal-wrapper`}>
                      {x.cards.map((x) => (
                        <div className="carousal-card cc-loader"></div>
                      ))}
                    </div>
                  ))
                : carousalList.map((obj) => (
                    <div className={`carousal-wrapper ${returnClassName(obj)}`}>
                      {obj.cards.map((x) => (
                        <div className="carousal-card">
                          <JobCard data={x} />
                        </div>
                      ))}
                    </div>
                  ))}
            </div>
            <div className="f-j-carousal-buttons">
              {carousalList.map((obj) => (
                <button
                  onClick={() => setSelectedJob(obj)}
                  className={
                    obj.belongsTo === selectedJob.belongsTo
                      ? "selected-dot"
                      : ""
                  }
                ></button>
              ))}
            </div>
          </div>
          <Link to="/user/list" className="f-j-s-explore">
            Explore Jobs
          </Link>
        </div>
      </section>
      <section className="candidate-how-it-works">
        <img src={Images.grayRay} className="gray-ray" />
        <div className="c-h-i-w-bg">
          <div>
            <img src={Images.dotsUp} />
            <img src={Images.dotsLow} />
          </div>
        </div>
        <div className="c-h-i-w-bg-left">
          <h2>
            Teachers, choose your career wisely! <span>It's free!</span>
          </h2>
          <p>
            Every hour, AcadsHR posts job listings from institutions around the
            world that are looking to hire and offer you a full package and
            great experience. We encourage you to Register, follow us on social
            media, and download our mobile apps.
          </p>
          <h2>
            How it <span>works</span>
          </h2>
          <p>Discover your passion for teaching.</p>
          <Link to="/login">Get Started</Link>
        </div>
        <div className="c-h-i-w-bg-right">
          {howItWorks.map((obj, num) => (
            <Link to={obj.route} className="card-row">
            <div data-aos="fade-left" key={obj.keyId} className="">
              <div className="card-wrapper">
                <h1>0{num + 1}</h1>
                <img src={obj.icon} alt="icon" />
                <h6>{obj.title}</h6>
                <p>{obj.para}</p>
              </div>
            </div>
            </Link>
          ))}
        </div>
      </section>
      <section className="our-services-section">
        <div className="o-s-s-left">
          {services.map((obj) => (
            <div key={obj.keyId}>
              <img src={obj.icon} alt="icon" />
              <h5>{obj.title}</h5>
              <p>{obj.para}</p>
            </div>
          ))}
        </div>
        <div className="o-s-s-right">
          <h4>
            Our <span>Services</span>
          </h4>
          <p>
            AcadsHR is one of the world’s largest independent job boards for
            educators. Register your CV to start applying today at your
            preferred locations. Our simple search tools and instant job matches
            increases your chance of landing a dream job.
          </p>
          {/* <ul>
            <li>
              Finding the ideal teacher for your institution in the most
              efficient manner.{" "}
            </li>
            <li>Achieving the best applicants for your posted positions.</li>
            <li>
              Dedicated HR can take care of all the HR administration needs of
              the institution, from hiring to exit
            </li>
          </ul>
          <p>
            Fortunately, there is a solution... AcadsHR! Please chat with us or
            connect with us.
          </p> */}
          <Link  to="/login">Get Started</Link>
        </div>
      </section>
      <section className="candidate-video-wrapper">
        <div className="video-wrapper-box">
          <div className="c-v-w-left">
            <h5 className="c-v-w-l-title">
              <img height="45px" src={Images.vedantuLogo} />
            </h5>
            <p className="c-v-w-l-para">
              Vedantu is an Indian online tutoring platform where teachers
              provide tuitions to students over the internet, using a real-time
              virtual learning environment named WAVE. It operates on a
              marketplace model for teachers, where students can browse,
              discover and choose to learn from an online tutor.
            </p>
            <div className="c-v-w-card-wrapper">
              <JobCard
                data={{
                  jobViewCount: 10,
                  custField1: "CBSE",
                  appliedCount: 27,
                  jobType: "Full time",
                  jobTitle: "English Teacher",
                  clientName: "Vedantu",
                  location: "Bangalore",
                  minWorkExp: 2,
                  minSalary: 20000,
                  maxSalary: 80000,
                }}
              />
            </div>
          </div>
          <div className="c-v-w-right">
            <div style={{ backgroundImage: `url('${Images.vedantuMain}')` }} />
          </div>
        </div>
      </section>
      <section className="other-logo-section">
        <div className="o-l-s-upper">
          <div className="o-l-s-left">
            <div className="ols-overlay-top" />
            <div className="ols-overlay-bottom" />
            <div className="clients-wrapper">
              {clients.map((obj) => (
                <div key={obj.keyId}>
                  <img src={obj.img} />
                </div>
              ))}
            </div>
          </div>
          <div className="o-l-s-right">
            <h4>
              Each day, <span>1000+</span> new applicants are being added to our
              teacher talent pool
            </h4>
            <p>
              We connect academicians with academies using our Tech platform for
              educational institutions and EdTech companies that are looking for
              academic talent.
            </p>
            <Link to="/login/candidate">Get Started</Link>
            {/* <img src={Images.mainLogo} /> */}
          </div>
        </div>
        <div className="o-l-s-lower">
          <div>
            <h6>
              Do you want teachers and mentors who can help your students grow?
            </h6>
            <p>Post a job now </p>
          </div>
          <Link to="/institution">Post a Job</Link>
        </div>
      </section>
      <section
        style={{ backgroundImage: `url('${Images.orangeRay}')` }}
        className="testimonials-wrapper"
      >
        {/* <img src={Images.orangeRay} /> */}
        <h3>
          Our <span>Testimonials</span>
        </h3>
        <div className="comment-switch">
          <div className={testimonials === "institute" ? "right-most" : ""} />
          {[
            { keyId: nextId(), id: "candidate", name: "From Candidates" },
            { keyId: nextId(), id: "institute", name: "From Institutes" },
          ].map((x) => (
            <h6
              className={x.id === testimonials ? "selected-switch" : ""}
              key={x.keyId}
              onClick={() => {
                setTestimonials(x.id);
                setSelectedComment(commentList[x.id][0]);
              }}
            >
              {x.name}
            </h6>
          ))}
        </div>
        <div className="comment-row">
          <div className="comment-wrapper">
            <img className="comma" src={Images.commas} />
            <img className="comma-inverted" src={Images.commasInverted} />

            <button
              onClick={() => handlePreviousButton()}
              className="previous-button"
            >
              <img src="https://img.icons8.com/fluency-systems-regular/48/000000/less-than.png" />
            </button>
            <button onClick={() => handleNextButton()} className="next-button">
              <img src="https://img.icons8.com/fluency-systems-regular/48/ffffff/more-than.png" />
            </button>
            <div className="comment-wrapper-second">
              {commentList[testimonials].map((obj) => (
                <div
                  key={obj.keyId}
                  className={`comment-card ${returnCommentClassName(obj)}`}
                >
                  <div>
                    {" "}
                    <p>
                      {obj.testimonial}
                      {obj.testimonial}
                    </p>
                  </div>

                  <h6>{obj.name}</h6>
                  <span>{obj.designation}</span>
                </div>
              ))}
            </div>
            <div className="comments-button">
              {commentList[testimonials].map((x) => (
                <button
                  className={
                    selectedComment._id === x._id ? "selected-button" : ""
                  }
                  onClick={() => setSelectedComment(x)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="company-banner">
        <div className="company-banner-box">
          <div className="company-banner-left">
            <img src={Images.mainLogo} alt="logo" />
            <h5>
              Get <span>updates</span> and <span>search</span> for opportunities
              right at your
              <span> finger tips</span>
            </h5>
            <p className="install-desc">
              Using the free app, you can easily search over 300 institutions &
              agencies.
            </p>
            <div>
              <span>Download the apps from</span>
              <p>
                <img src={Images.playStore} />
                <img src={Images.blueApple} />
              </p>
            </div>
          </div>
          <div
            style={{ backgroundImage: `url("${Images.phoneHand}")` }}
            className="company-banner-right"
          ></div>
        </div>
      </section>
      <section className="top-institute-list">
        <h2>
          Top <span>Institutions</span>
        </h2>
        <div className="institute-list-wrapper">
          {instituteList.map((obj) => (
            <div key={obj.keyId} className="institute-card">
              <div className="institute-image">
                <img src={obj.image} />
              </div>
              <div className="institute-details">
                <h5 title={obj.name}>{obj.name}</h5>
                <p>{obj.place}</p>
                <div>
                  <button>{obj.opening} position open</button>
                  {/* <button>
                    Apply now <img src={Images.orangeRightLogo} />
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <CommonFooter />
    </div>
  );
}
const array = [
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
  { keyId: nextId() },
];
const howItWorks = [
  {
    keyId: nextId(),
    title: "Create a profile",
    icon: Images.cvMan,
    route: "/sign-up/candidate",
    para: "Get the right job recommendations by building your profile and entering all the details. Get started with your new teaching career at your preferred location.",
  },
  {
    keyId: nextId(),
    icon: Images.applyJob,
    title: "Explore your dream job",
    route: "/user/list",
    para: "Whether you're looking for online or offline jobs, full-time or part-time jobs or work from home. You can apply from the comfort of your home.",
  },
  {
    keyId: nextId(),
    icon: Images.suitcaseLogo,
    route: "/institute",
    title: "Join the Dream Team",
    para: "Review about the institution or companies before consider joining. Also, please review your current/past institution/company, as this helps other future educators.",
  },
];

const services = [
  {
    keyId: nextId(),
    title: "Resume Builder",
    icon: Images.newResume,
    para: "You no longer must worry about how to make a resume. Choose professional, elegant, creative, or modern resume services through AcadsHR.",
    anim: "fade-down-right",
  },
  {
    keyId: nextId(),
    icon: Images.newWorld,
    title: "Teach Abroad",
    para: "Make your dream a reality. Create your profile and we'll connect you with international schools who are hiring now. ",
    anim: "fade-down-left",
  },
  {
    keyId: nextId(),
    icon: Images.newPC,
    title: "Teach Online",
    para: "Teach online no matter where you are in the world, whether it's part-time or full-time. Students of all ages and from all over the world can learn from you.",
    anim: "fade-up-right",
  },
  {
    keyId: nextId(),
    icon: Images.callCenter,
    title: "Career Guidance",
    para: "During your career exploration, our mentor will assist you in setting goals, aiming for success, providing emotional support, and modelling the correct career path for you.",
    anim: "fade-up-right",
  },
];

const instituteList = [
  {
    keyId: nextId(),
    image: Images.schoolOne,
    name: "DPNC GLOBAL LLP",
    place: "Bangalore Urban, Karnataka, India",
    opening: 4,
  },
  {
    keyId: nextId(),
    image: Images.schoolTwo,
    name: "Vedantu",
    place: "Hubli, Karnataka, India",
    opening: 2,
  },
  {
    keyId: nextId(),
    image: Images.schoolThree,
    name: "Diyar International Private School",
    place: "Mumbai, Maharashtra, India",
    opening: 6,
  },
  {
    keyId: nextId(),
    image: Images.schoolFour,
    name: "Tattva School",
    place: "Panjim, Goa, India",
    opening: 3,
  },
];

const clients = [
  { keyId: nextId(), img: Images.clientOne },
  { keyId: nextId(), img: Images.clientTwo },
  { keyId: nextId(), img: Images.clientThree },
  { keyId: nextId(), img: Images.clientFour },
  { keyId: nextId(), img: Images.clientFive },
  { keyId: nextId(), img: Images.clientSix },
  { keyId: nextId(), img: Images.clientSeven },
  { keyId: nextId(), img: Images.clientEight },
  { keyId: nextId(), img: Images.clientNine },
  { keyId: nextId(), img: Images.client10 },
  { keyId: nextId(), img: Images.client11 },
  { keyId: nextId(), img: Images.client12 },
  { keyId: nextId(), img: Images.client13 },
  { keyId: nextId(), img: Images.client14 },
  { keyId: nextId(), img: Images.client15 },
  { keyId: nextId(), img: Images.client16 },
  { keyId: nextId(), img: Images.client17 },
  { keyId: nextId(), img: Images.client18 },
  { keyId: nextId(), img: Images.client19 },
  { keyId: nextId(), img: Images.client20 },
  { keyId: nextId(), img: Images.client21 },
  { keyId: nextId(), img: Images.client22 },
  { keyId: nextId(), img: Images.client23 },
  { keyId: nextId(), img: Images.client24 },
  { keyId: nextId(), img: Images.client25 },
  { keyId: nextId(), img: Images.client26 },
  { keyId: nextId(), img: Images.client27 },
  { keyId: nextId(), img: Images.client28 },
  { keyId: nextId(), img: Images.client29 },
  { keyId: nextId(), img: Images.client30 },
  { keyId: nextId(), img: Images.client31 },
  { keyId: nextId(), img: Images.client32 },
  { keyId: nextId(), img: Images.client33 },
  { keyId: nextId(), img: Images.client35 },
  { keyId: nextId(), img: Images.client36 },
  { keyId: nextId(), img: Images.client38 },
  { keyId: nextId(), img: Images.client39 },
  { keyId: nextId(), img: Images.client40 },
  { keyId: nextId(), img: Images.client41 },
  { keyId: nextId(), img: Images.client42 },
  { keyId: nextId(), img: Images.client43 },
  { keyId: nextId(), img: Images.client44 },
  { keyId: nextId(), img: Images.client45 },
  { keyId: nextId(), img: Images.client46 },
  { keyId: nextId(), img: Images.client47 },
  { keyId: nextId(), img: Images.client48 },
  { keyId: nextId(), img: Images.client49 },
  { keyId: nextId(), img: Images.client50 },

  { keyId: nextId(), img: Images.client51 },
  // { keyId: nextId(), img: Images.clientNine },
];
